import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FakeText } from '@totalsoft/rocket-ui';
import QuestionDetailListItemComponent from './QuestionDetailListItemComponent';
import { Table, TableCell, TableBody, TableRow, TableHead, Grid, Tooltip, Toolbar, IconButton, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

const QuestionDetailListCard = ({
  loading,
  questionIndex,
  questionId,
  validation,
  isReadOnly,
  onDetailPropertyChanged,
  onAddNewQuestionDetailRow,
  onDeleteQuestionDetailRow,
  questionDetails
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Toolbar>
        <Grid container spacing={1} justifyContent='flex-start'>
          <Typography variant='subtitle1'>{t('Questionnaire.Question.QuestionDetail.QuestionDetailsSubtitle')}</Typography>
        </Grid>
        <Grid container justifyContent='flex-end'>
          <Grid item>
            <Tooltip title={t('Tooltips.Questionnaire.AddQuestionDetail')}>
              <div>
                <IconButton color='primary' onClick={onAddNewQuestionDetailRow(questionIndex, questionId)} disabled={isReadOnly}>
                  <Add />
                </IconButton>
              </div>
            </Tooltip>
          </Grid>
        </Grid>
      </Toolbar>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 7 / 20 }}>{t('Questionnaire.Question.QuestionDetail.QuestionDetailCode')}</TableCell>
            <TableCell sx={{ width: 7 / 20 }}>{t('Questionnaire.Question.QuestionDetail.QuestionValue')}</TableCell>
            <TableCell>{t('Questionnaire.Question.QuestionDetail.IsDefault')}</TableCell>
            <TableCell>{t('Questionnaire.Question.QuestionDetail.QuestionScore')}</TableCell>
            <TableCell>{t('Questionnaire.Actions')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={2}>
                <FakeText lines={10} />
              </TableCell>
            </TableRow>
          ) : (
            questionDetails.map((item, idx) => {
              return (
                <QuestionDetailListItemComponent
                  key={idx}
                  questionIndex={questionIndex}
                  validation={validation[idx]}
                  item={item}
                  questionDetailIndex={idx}
                  isReadOnly={isReadOnly}
                  onDetailPropertyChanged={onDetailPropertyChanged}
                  onDeleteQuestionDetailRow={onDeleteQuestionDetailRow}
                />
              );
            })
          )}
        </TableBody>
      </Table>
    </>
  );
};

QuestionDetailListCard.propTypes = {
  loading: PropTypes.bool.isRequired,
  questionDetails: PropTypes.array.isRequired,
  questionId: PropTypes.number,
  questionIndex: PropTypes.number,
  validation: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  onDetailPropertyChanged: PropTypes.func.isRequired,
  onAddNewQuestionDetailRow: PropTypes.func.isRequired,
  onDeleteQuestionDetailRow: PropTypes.func.isRequired
};

export default QuestionDetailListCard;
